import { Award, CalendarDays, FileText, LayoutDashboard, MessageSquare, Settings, Stethoscope, UserRound, type LucideIcon } from 'lucide-react';
import { DOCTOR_ROOT_PATH, PORTAL_ROOT_PATH } from '@/portal/config';
import type { PortalTextKey } from '@/portal/i18n/portalText';

export interface PortalNavItem {
  to: string;
  labelKey: PortalTextKey;
  icon: LucideIcon;
  end?: boolean;
  inTabBar?: boolean;
}

export const portalNavItems: PortalNavItem[] = [
  { to: PORTAL_ROOT_PATH, labelKey: 'navDashboard', icon: LayoutDashboard, end: true },
  { to: `${PORTAL_ROOT_PATH}/visits`, labelKey: 'navVisits', icon: CalendarDays },
  { to: `${PORTAL_ROOT_PATH}/results`, labelKey: 'navResults', icon: FileText },
  { to: `${PORTAL_ROOT_PATH}/points`, labelKey: 'navPoints', icon: Award, inTabBar: false },
  { to: `${PORTAL_ROOT_PATH}/complaints`, labelKey: 'navComplaints', icon: MessageSquare, inTabBar: false },
  { to: `${PORTAL_ROOT_PATH}/profile`, labelKey: 'navProfile', icon: UserRound },
];

export const doctorNavItems: PortalNavItem[] = [
  { to: DOCTOR_ROOT_PATH, labelKey: 'drNavOverview', icon: Stethoscope, end: true },
  { to: `${DOCTOR_ROOT_PATH}/results`, labelKey: 'drNavResults', icon: FileText },
  { to: `${DOCTOR_ROOT_PATH}/settings`, labelKey: 'drNavSettings', icon: Settings },
];

export const navItemsFor = (role: 'customer' | 'doctor'): PortalNavItem[] =>
  role === 'doctor' ? doctorNavItems : portalNavItems;
